import layoutsView from '@/views/layoutsView'


// 模拟路由数据
const routerData = [{ //登录注册模块
    path: '/entrance',
    name: 'entrance',
    component: () => import( /* webpackChunkName: "login" */
      '@/components/paging/pcClient/loginRegisteredModule/entrance'),
    redirect: '/entrance/login',
    children: [{ //登录
      path: '/entrance/login',
      name: 'login',
      component: () => import( /* webpackChunkName: "login" */
        '@/components/paging/pcClient/loginRegisteredModule/subassembly/login'),
    }]
  },
  { // 登录控制台
    path: '/consoleStation',
    name: 'consoleStation',
    component: () => import( /* webpackChunkName: "login" */
      '@/components/paging/pcClient/consoleStationModule/index2')
  },
  { //智能报表大屏
    path: '/projectsubject/businessAdministration/largeScreen',
    name: 'largeScreen',
    component: () => import( /* webpackChunkName: "largeScreen" */
      '@/components/paging/pcClient/convenienceModule/businessAdministration/intelligenceReports/largeScreen'
    ),
  },
  { //主要内容路由
    path: '/projectsubject',
    name: 'projectsubject',
    component: () => import( /* webpackChunkName: "projectsubject" */ '@/components/paging/pcClient/projectSubject'),
    children: [{ //未加入企业用户入口
        path: '/projectsubject/jurisdiction',
        name: 'jurisdiction',
        component: () => import( /* webpackChunkName: "jurisdiction" */
          '@/components/paging/pcClient/convenienceModule/jurisdiction/jurisdiction'),
        redirect: '/projectsubject/jurisdiction/skipPage',
        children: [{ //加入主页
            path: '/projectsubject/jurisdiction/skipPage',
            name: 'skipPage',
            meta: {
              name: "加入或创建企业",
              id: "A0000",
              icon: "iconfont icon-loufang101",
              router: "/projectsubject/jurisdiction/skipPage",
            },
            component: () => import( /* webpackChunkName: "jurisdiction" */
              '@/components/paging/pcClient/convenienceModule/jurisdiction/join/skipPage'),
          },
          { //创建自己的企业
            path: '/projectsubject/jurisdiction/createenterprise',
            name: 'createEnterprise',
            component: () => import( /* webpackChunkName: "jurisdiction" */
              '@/components/paging/pcClient/convenienceModule/jurisdiction/join/createEnterprise'),
          },
          { //加入已有的企业
            path: '/projectsubject/jurisdiction/joinTheEnterprise',
            name: 'joinTheEnterprise',
            component: () => import( /* webpackChunkName: "jurisdiction" */
              '@/components/paging/pcClient/convenienceModule/jurisdiction/join/joinTheEnterprise'),
          },
        ]
      },
      {
        path: '/projectsubject/administrative',
        name: 'administrative',
        component: () => import( /* webpackChunkName: "administrative" */
          '@/components/paging/pcClient/convenienceModule/administrativeHome/administrative'),
        redirect: '/projectsubject/administrative/projectDistribution',
        children: [{ //项目分包
            path: '/projectsubject/administrative/projectDistribution',
            name: 'projectDistribution',
            component: () => import( /* webpackChunkName: "administrative" */
              '@/components/paging/pcClient/convenienceModule/administrativeHome/home/projectDistribution'),
          },
          { //投资进度
            path: '/projectsubject/administrative/InvestmentProgress',
            name: 'InvestmentProgress',
            component: () => import( /* webpackChunkName: "administrative" */
              '@/components/paging/pcClient/convenienceModule/administrativeHome/home/InvestmentProgress'),
          },
          { //质量安全
            path: '/projectsubject/administrative/QSMark',
            name: 'QSMark',
            component: () => import( /* webpackChunkName: "administrative" */
              '@/components/paging/pcClient/convenienceModule/administrativeHome/home/QSMark'),
          },
        ]
      },
      // { //新闻咨询
      //   path: '/projectsubject/newsConsulting',
      //   name: 'newsConsulting',
      //   component: () => import( /* webpackChunkName: "newsConsulting" */
      //     '@/components/paging/pcClient/convenienceModule/newsConsulting/newsConsulting'),
      // },
      { //园区管理
        path: '/projectsubject/businessAdministration',
        name: 'businessAdministration',
        component: () => import( /* webpackChunkName: "businessAdministration" */
          '@/components/paging/pcClient/convenienceModule/businessAdministration/businessAdministration'),
        // meta: {
        // 	ifSkip: true
        // },
        redirect: '/projectsubject/businessAdministration/busCard',
        children: [
          // { //企业名片
          //   path: '/projectsubject/businessAdministration/busCard',
          //   name: 'busCard',
          //   component: () => import( /* webpackChunkName: "businessAdministration" */
          //     '@/components/paging/pcClient/convenienceModule/businessAdministration/busCard/busCard'),
          // },
          { //项目进度
            path: '/projectsubject/project/schedule',
            name: 'schedule',
            // meta: {
            //   menuIndex: true
            // },
            component: () => import( /* webpackChunkName: "businessAdministration" */
              '@/components/paging/pcClient/convenienceModule/project/schedule'),
          },
          { //问题汇总--------后期完成
            path: '/projectsubject/problemSummary',
            name: 'problemSummary',
            // meta: {
            //   menuIndex: true
            // },
            component: () => import( /* webpackChunkName: "businessAdministration" */
              '@/components/paging/pcClient/convenienceModule/problemSummary'),
          },
          { //问题汇总详情--------后期完成
            path: '/projectsubject/problemSummary/details',
            name: 'problemSummaryDetails',
            // meta: {
            //   menuIndex: true
            // },
            component: () => import( /* webpackChunkName: "businessAdministration" */
              '@/components/paging/pcClient/convenienceModule/problemSummary/details'),
          },
          { //工单督办
            path: '/projectsubject/businessAdministration/workOrder',
            name: 'workOrder',
            component: () => import( /* webpackChunkName: "workOrder" */
              '@/components/paging/pcClient/convenienceModule/businessAdministration/workOrder'
            ),
          },
          { //下发工单
            path: '/projectsubject/businessAdministration/workOrderLssue',
            name: 'workOrderLssue',
            meta: {
              menuIndex: true
            },
            component: () => import( /* webpackChunkName: "workOrder" */
              '@/components/paging/pcClient/convenienceModule/businessAdministration/workOrder/workOrderLssue'
            ),
          },
          { //工单详情
            path: '/projectsubject/businessAdministration/workOrderDetail',
            name: 'workOrderDetail',
            meta: {
              menuIndex: true
            },
            component: () => import( /* webpackChunkName: "workOrder" */
              '@/components/paging/pcClient/convenienceModule/businessAdministration/workOrder/workOrderDetail'
            ),
          },
          // { // bim 测试
          //   path: '/projectsubject/businessAdministration/bimTamplate',
          //   name: 'bimTamplate',
          //   component: () => import( /* webpackChunkName: "businessAdministration" */ '@/components/paging/pcClient/convenienceModule/businessAdministration/bimTamplate/index'),
          // },
          { //智能报表
            path: '/projectsubject/businessAdministration/intelligenceReports',
            name: 'intelligenceReports',
            component: () => import( /* webpackChunkName: "intelligenceReports" */
              '@/components/paging/pcClient/convenienceModule/businessAdministration/intelligenceReports/intelligenceReports'
            ),
          },
          { //园区人员
            path: '/projectsubject/businessAdministration/enterprisePersonnel',
            name: 'enterprisePersonnel',
            component: () => import( /* webpackChunkName: "enterprisePersonnel" */
              '@/components/paging/pcClient/convenienceModule/businessAdministration/enterprisePersonnel/enterprisePersonnel'
            ),
          },
          { //入园申请
            path: '/projectsubject/businessAdministration/applyfor',
            name: 'applyfor',
            component: () => import( /* webpackChunkName: "administrative" */
              '@/components/paging/pcClient/convenienceModule/businessAdministration/applyfor/applyfor'),
          },
          // { //企业证书
          //   path: '/projectsubject/businessAdministration/cerManage',
          //   name: 'cerManage',
          //   component: () => import( /* webpackChunkName: "cerManage" */
          //     '@/components/paging/pcClient/convenienceModule/businessAdministration/cerManage/cerManage'),
          //   redirect: '/projectsubject/businessAdministration/cerManage/cerManageTable',
          //   children: [{ //证书列表
          //       path: '/projectsubject/businessAdministration/cerManage/cerManageTable',
          //       name: 'cerManageTable',
          //       component: () => import( /* webpackChunkName: "cerManage" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/cerManage/cerManageModule/cerManageTable'
          //       ),
          //     },
          //     { //添加证书
          //       path: '/projectsubject/businessAdministration/cerManage/cerManageFrom',
          //       name: 'cerManageFrom',
          //       meta: {
          //         menuIndex: '/projectsubject/businessAdministration/cerManage/cerManageTable'
          //       },
          //       component: () => import( /* webpackChunkName: "cerManage" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/cerManage/cerManageModule/cerManageFrom'
          //       ),
          //     },
          //     { //证书详情
          //       path: '/projectsubject/businessAdministration/cerManage/cerManageDetails',
          //       name: 'cerManageDetails',
          //       meta: {
          //         menuIndex: '/projectsubject/businessAdministration/cerManage/cerManageTable'
          //       },
          //       component: () => import( /* webpackChunkName: "cerManage" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/cerManage/cerManageModule/cerManageDetails'
          //       ),
          //     },
          //     { //证书批量借用
          //       path: '/projectsubject/businessAdministration/cerManage/cerManageBatchBorrow',
          //       name: 'cerManageBatchBorrow',
          //       meta: {
          //         menuIndex: '/projectsubject/businessAdministration/cerManage/cerManageTable'
          //       },
          //       component: () => import( /* webpackChunkName: "cerManage" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/cerManage/cerManageModule/cerManageBatchBorrow'
          //       ),
          //     },
          //   ]
          // },
          // { //财务管理
          //   path: '/projectsubject/businessAdministration/financialManagement',
          //   name: 'financialManagement',
          //   component: () => import( /* webpackChunkName: "financialManagement" */
          //     '@/components/paging/pcClient/convenienceModule/businessAdministration/financialManagement/financialManagement'
          //   ),
          //   redirect: '/projectsubject/businessAdministration/financialManagement/projectFunds',
          //   children: [{ //工程款
          //       path: '/projectsubject/businessAdministration/financialManagement/projectFunds',
          //       name: 'projectFunds',
          //       component: () => import( /* webpackChunkName: "financialManagement" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/financialManagement/projectFunds/projectFunds'
          //       ),
          //     },
          //     { //项目记录
          //       path: '/projectsubject/businessAdministration/financialManagement/projectFunds/collectionData',
          //       name: 'collectionData',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "financialManagement" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/financialManagement/projectFunds/projectFundsAll/collectionDetail/collectionData'
          //       ),
          //     },
          //     { //拨付记录
          //       path: '/projectsubject/businessAdministration/financialManagement/projectFunds/collectionData/collectionPersonnelDetails',
          //       name: 'collectionPersonnelDetails',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "financialManagement" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/financialManagement/projectFunds/projectFundsAll/collectionDetail/collectionPersonnelDetails'
          //       ),
          //     },
          //     {
          //       path: '/projectsubject/businessAdministration/financialManagement/projectFunds/fundsDes',
          //       name: 'fundsDes',
          //       meta: {
          //         menuIndex: '/projectsubject/businessAdministration/financialManagement/projectFunds'
          //       },
          //       component: () => import( /* webpackChunkName: "financialManagement" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/financialManagement/projectFunds/fundsdes'
          //       ),
          //     },
          //     { //保证金
          //       path: '/projectsubject/businessAdministration/financialManagement/marginMoney',
          //       name: 'marginMoney',
          //       component: () => import( /* webpackChunkName: "financialManagement" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/financialManagement/marginMoney/manage'
          //       ),
          //     },
          //   ]
          // },
          // { //电子签章
          //   path: '/projectsubject/businessAdministration/sealList',
          //   name: 'sealList',
          //   component: () => import( /* webpackChunkName: "sealList" */
          //     '@/components/paging/pcClient/convenienceModule/businessAdministration/sealList/sealList'),
          //   redirect: '/projectsubject/businessAdministration/sealList/sealManage',
          //   children: [{ //印章管理
          //       path: '/projectsubject/businessAdministration/sealList/sealManage',
          //       name: 'sealManage',
          //       component: () => import( /* webpackChunkName: "sealList" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/sealList/sealApplyForFile/sealManage'
          //       ),
          //     },
          //     { //盖章文件列表
          //       path: '/projectsubject/businessAdministration/sealApplyFor',
          //       name: 'sealApplyFor',
          //       component: () => import( /* webpackChunkName: "sealList" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/sealList/sealApplyForFile/sealApplyFor'
          //       ),
          //     },
          //     { //盖章申请
          //       path: '/projectsubject/businessAdministration/sealApplyForDetails',
          //       name: 'sealApplyForDetails',
          //       component: () => import( /* webpackChunkName: "sealList" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/sealList/sealApplyForFile/sealApplyForDetails'
          //       ),
          //     },
          //   ]
          // },
          // { // 出差管理
          //   path: '/projectsubject/businessAdministration/onBusiness',
          //   name: 'onBusiness',
          //   component: () => import( /* webpackChunkName: "onBusiness" */
          //     '@/components/paging/pcClient/convenienceModule/businessAdministration/onBusiness/onBusiness'),
          //   redirect: '/projectsubject/businessAdministration/onBusiness/onBusinessStatistics',
          //   children: [{ // 出差统计
          //       path: '/projectsubject/businessAdministration/onBusiness/onBusinessStatistics',
          //       name: 'onBusinessStatistics',
          //       component: () => import( /* webpackChunkName: "onBusiness" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/onBusiness/onBusinessStatistics/onBusinessStatistics'
          //       ),
          //     },
          //     { // 出差记录（企业）
          //       path: '/projectsubject/businessAdministration/onBusiness/companyRecord',
          //       name: 'companyRecord',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "onBusiness" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/onBusiness/onBusinessStatistics/companyRecord'
          //       ),
          //     },
          //     { // 出差记录（个人）
          //       path: '/projectsubject/businessAdministration/onBusiness/onBusinessRecord',
          //       name: 'onBusinessRecord',
          //       component: () => import( /* webpackChunkName: "onBusiness" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/onBusiness/onBusinessRecord/onBusinessRecord'
          //       ),
          //     },
          //     { //出差申请
          //       path: '/projectsubject/businessAdministration/onBusiness/addOnBusiness',
          //       name: 'addOnBusiness',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "cerManage" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/onBusiness/onBusinessRecord/addOnBusiness'
          //       ),
          //     },
          //     { // 出差审批
          //       path: '/projectsubject/businessAdministration/onBusiness/onBusinessApprove',
          //       name: 'onBusinessApprove',
          //       component: () => import( /* webpackChunkName: "onBusiness" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/onBusiness/onBusinessApprove/onBusinessApprove'
          //       ),
          //     },
          //     { // 出差审批详情页
          //       path: '/projectsubject/businessAdministration/onBusiness/businessApproveDetails',
          //       name: 'businessApproveDetails',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "onBusiness" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/onBusiness/onBusinessApprove/businessApproveDetails'
          //       ),
          //     },
          //   ]
          // },
          // { // 企业合同管理
          //   path: '/projectsubject/businessAdministration/comparyContract',
          //   name: 'comparyContract',
          //   component: () => import( /* webpackChunkName: "comtract" */
          //     '@/components/paging/pcClient/convenienceModule/businessAdministration/contract/contract'),
          //   redirect: '/projectsubject/businessAdministration/comparyContract/allComparyContract',
          //   children: [{ // 所有项目合同
          //       path: '/projectsubject/businessAdministration/comparyContract/allComparyContract',
          //       name: 'allComparyContract',
          //       component: () => import( /* webpackChunkName: "comtract" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/contract/contractTable/contractTable'
          //       ),
          //     },
          //     { // 企业级合同
          //       path: '/projectsubject/businessAdministration/comparyContract/comparyContract',
          //       name: 'comparyContract',
          //       component: () => import( /* webpackChunkName: "comtract" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/contract/contractTable/contractTable'
          //       ),
          //     },
          //     { // 合同详情
          //       path: '/projectsubject/businessAdministration/comparyContract/allContractDetails',
          //       name: 'allContractDetails',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "comtract" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/contract/contractDetails/contractDetails'
          //       ),
          //     }
          //   ]
          // },
          // { //项目阶段列表
          //   path: '/projectsubject/businessAdministration/enterPriseProject/enterPriseProjectStage',
          //   name: 'enterPriseProjectStage',
          //   component: () => import( /* webpackChunkName: "enterPriseProject" */
          //     '@/components/paging/pcClient/convenienceModule/businessAdministration/enterPriseProject/enterPriseProjectStage'
          //   )
          // },
          // { // 企业公告
          //   path: '/projectsubject/businessAdministration/notice',
          //   name: 'companyNotice',
          //   component: () => import( /* webpackChunkName: "companyNotice" */
          //     '@/components/paging/pcClient/convenienceModule/businessAdministration/notice/notice'),
          //   redirect: '/projectsubject/businessAdministration/companyNoticeList',
          //   children: [{ // 企业公告列表
          //       path: '/projectsubject/businessAdministration/companyNoticeList',
          //       name: 'companyNoticeList',
          //       component: () => import( /* webpackChunkName: "companyNoticeList" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/notice/noticeFiles/noticeList'
          //       ),
          //     },
          //     { // 添加编辑公告
          //       path: '/projectsubject/businessAdministration/editNotice',
          //       name: 'editNotice',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "editNotice" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/notice/noticeFiles/editNotice'
          //       ),
          //     },
          //     { // 企业公告详情
          //       path: '/projectsubject/businessAdministration/noticeDetail',
          //       name: 'noticeDetail',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "noticeDetail" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/notice/noticeFiles/noticeDetail'
          //       ),
          //     },
          //   ]
          // },
          // { // 商务报价
          //   name: "commercialQuotation",
          //   path: "/projectsubject/businessAdministration/commercialQuotation",
          //   component: () => import( /* webpackChunkName: "commercialQuotation" */
          //     '@/components/paging/pcClient/convenienceModule/businessAdministration/commercialQuotation/commercialQuotation'
          //   ),
          //   redirect: "/projectsubject/businessAdministration/commercialQuotation/commercialQuotationTable",
          //   children: [{ // 商务报价列表
          //       path: "/projectsubject/businessAdministration/commercialQuotation/commercialQuotationTable",
          //       name: 'commercialQuotationTable',
          //       component: () => import( /* webpackChunkName: "commercialQuotation" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/commercialQuotation/content/commercialQuotationTable'
          //       ),
          //     },
          //     { // 商务报价详情
          //       name: 'commercialQuotationDetails',
          //       path: "/projectsubject/businessAdministration/commercialQuotation/commercialQuotationDetails",
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "commercialQuotation" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/commercialQuotation/content/commercialQuotationDetails'
          //       ),
          //     },
          //     { // 商务报价操作
          //       name: 'commercialQuotationOperation',
          //       path: "/projectsubject/businessAdministration/commercialQuotation/commercialQuotationOperation",
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "commercialQuotation" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/commercialQuotation/content/commercialQuotationOperation'
          //       ),
          //     }
          //   ]
          // },
        ]
      },
      // { //人事管理
      //   path: '/projectsubject/personnelManagement',
      //   name: 'personnelManagement',
      //   component: layoutsView,
      //   redirect: '/projectsubject/personnelManagement/leaveModule',
      //   children: [{
      //     path: '/projectsubject/personnelManagement/leaveModule',
      //     name: 'leaveModule',
      //     component: layoutsView,
      //     redirect: '/projectsubject/personnelManagement/leaveModule/leaveView',
      //     children: [{ //假勤管理
      //         path: '/projectsubject/personnelManagement/leaveModule/leaveView',
      //         name: 'leaveView',
      //         component: layoutsView,
      //         redirect: {
      //           name: 'leaveList'
      //         },
      //         children: [{ // 请假
      //             path: '/projectsubject/personnelManagement/leaveModule/leaveList',
      //             name: 'leaveList',
      //             meta: {
      //               // menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personnelPublicList'
      //             )
      //           },
      //           { // 请假详情
      //             path: '/projectsubject/personnelManagement/leaveModule/leaveDetail',
      //             name: 'leaveDetail',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personnelPublicDetail'
      //             )
      //           },
      //           { // 外勤
      //             path: '/projectsubject/personnelManagement/leaveModule/fieldList',
      //             name: 'fieldList',
      //             meta: {
      //               // menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personnelPublicList'
      //             )
      //           },
      //           { // 外勤详情
      //             path: '/projectsubject/personnelManagement/leaveModule/fieldDetail',
      //             name: 'fieldDetail',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personnelPublicDetail'
      //             )
      //           },
      //           { // 加班
      //             path: '/projectsubject/personnelManagement/leaveModule/overtimeList',
      //             name: 'overtimeList',
      //             meta: {
      //               // menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personnelPublicList'
      //             )
      //           },
      //           { // 加班详情
      //             path: '/projectsubject/personnelManagement/leaveModule/overtimeDetail',
      //             name: 'overtimeDetail',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personnelPublicDetail'
      //             )
      //           },
      //           { // 补卡
      //             path: '/projectsubject/personnelManagement/leaveModule/makeUpCardList',
      //             name: 'makeUpCardList',
      //             meta: {
      //               // menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/makeUpCardList'
      //             )
      //           },
      //           { // 补卡详情
      //             path: '/projectsubject/personnelManagement/leaveModule/makeUpCardDetail',
      //             name: 'makeUpCardDetail',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personnelPublicDetail'
      //             )
      //           },
      //           { // 考勤设置
      //             path: '/projectsubject/personnelManagement/leaveModule/attendanceList',
      //             name: 'attendanceList',
      //             meta: {
      //               // menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personnelattendance'
      //             )
      //           },
      //           { // 考勤设置(新增设置)
      //             path: '/projectsubject/personnelManagement/leaveModule/attendanceList/machineSet',
      //             name: 'machineSet',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personnelattendance/machineSet'
      //             )
      //           },
      //           { // 考勤设置(考勤机组配置)
      //             path: '/projectsubject/personnelManagement/leaveModule/attendanceList/groupSet',
      //             name: 'groupSet',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personnelattendance/groupSet'
      //             )
      //           },
      //           { // 考勤设置详情
      //             path: '/projectsubject/personnelManagement/leaveModule/attendanceDetail',
      //             name: 'attendanceDetail',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personnelattendance/attendanceDetail'
      //             )
      //           },
      //           { // 考勤统计
      //             path: '/projectsubject/personnelManagement/leaveModule/attendanceStatistics',
      //             name: 'attendanceStatistics',
      //             meta: {
      //               // menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/attendanceStatistics'
      //             )
      //           },
      //           { // 考勤统计详情
      //             path: '/projectsubject/personnelManagement/leaveModule/attendanceStatisticsDetail',
      //             name: 'attendanceStatisticsDetail',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/attendanceStatistics/attendanceStatisticsDetail'
      //             )
      //           },
      //         ]
      //       },
      //       { //人事档案
      //         path: '/projectsubject/personnelManagement/archivesModule/archivesView',
      //         name: 'archivesView',
      //         component: layoutsView,
      //         redirect: {
      //           name: 'employeeFile'
      //         },
      //         children: [{ // 员工档案
      //             path: '/projectsubject/personnelManagement/archivesModule/employeeFile',
      //             name: 'employeeFile',
      //             meta: {
      //               // menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/employeeFile'
      //             )
      //           },
      //           { // 员工档案详情
      //             path: '/projectsubject/personnelManagement/leaveModule/employeeDetail',
      //             name: 'employeeFileDetail',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/employeeFile/employeeDetail'
      //             )
      //           },
      //           { // 入职管理
      //             path: '/projectsubject/personnelManagement/archivesModule/induction',
      //             name: 'induction',
      //             meta: {
      //               // menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/employeeFile'
      //             )
      //           },
      //           { // 入职管理详情
      //             path: '/projectsubject/personnelManagement/leaveModule/inductionDetail',
      //             name: 'inductionDetail',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/employeeFile/employeeDetail'
      //             )
      //           },
      //           { // 转正记录
      //             path: '/projectsubject/personnelManagement/archivesModule/onTrial',
      //             name: 'onTrial',
      //             meta: {
      //               // menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/employeeFile'
      //             )
      //           },
      //           { // 转正记录详情
      //             path: '/projectsubject/personnelManagement/leaveModule/onTrialDetail',
      //             name: 'onTrialDetail',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/employeeFile/employeeDetail'
      //             )
      //           },
      //           { // 离职记录
      //             path: '/projectsubject/personnelManagement/archivesModule/quit',
      //             name: 'quit',
      //             meta: {
      //               // menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/employeeFile'
      //             )
      //           },
      //           { // 离职记录详情
      //             path: '/projectsubject/personnelManagement/leaveModule/quitDetail',
      //             name: 'quitDetail',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/employeeFile/employeeDetail'
      //             )
      //           },
      //         ]
      //       },
      //       { //个人档案
      //         path: '/projectsubject/personnelManagement/personalArchivesModule/personalArchivesView',
      //         name: 'personalArchivesView',
      //         component: layoutsView,
      //         redirect: {
      //           name: 'personalArchives'
      //         },
      //         children: [{ // 个人档案
      //             path: '/projectsubject/personnelManagement/personalArchivesModule/personalArchives',
      //             name: 'personalArchives',
      //             meta: {
      //               // menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personalArchives'
      //             )
      //           },
      //           { // 个人档案详情
      //             path: '/projectsubject/personnelManagement/personalArchivesModule/personalArchivesDetail',
      //             name: 'personalArchivesDetail',
      //             meta: {
      //               menuIndex: true
      //             },
      //             component: () => import( /* webpackChunkName: "personnelManagement" */
      //               '@/components/paging/pcClient/convenienceModule/personnelManagement/personalArchives/personalArchivesDetail'
      //             )
      //           }
      //         ]
      //       }
      //     ]
      //   }]
      // },
      // { //项目管理
      //   path: '/projectsubject/projectManagement',
      //   name: 'projectManagement',
      //   component: () => import( /* webpackChunkName: "projectManagement" */
      //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectManagement'),
      //   redirect: '/projectsubject/projectManagement/listMessage',
      //   children: [
      { //项目管理
        path: '/projectsubject/projectManagement/listMessage',
        name: 'listMessage',
        component: () => import( /* webpackChunkName: "projectManagement" */
          '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/listMessage'),
        redirect: '/projectsubject/projectManagement/listMessage/projectList',
        children: [{ //添加项目
            path: '/projectsubject/projectManagement/listMessage/newCon',
            name: 'newCon',
            meta: {
              menuIndex: true
            },
            component: () => import( /* webpackChunkName: "projectManagement" */
              '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/listMessage_seed/newCon'
            ),
          },
          { //项目列表
            path: '/projectsubject/projectManagement/listMessage/projectList',
            name: 'projectList',
            component: () => import( /* webpackChunkName: "projectManagement" */
              '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/listMessage_seed/projectList'
            ),
          },
          { //初始化项目
            path: '/projectsubject/projectManagement/listMessage/projectInit',
            name: 'projectInit',
            component: () => import( /* webpackChunkName: "projectManagement" */
              '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/projectInit/projectInit'
            ),
          },
          { //初始化项目预览
            path: '/projectsubject/projectManagement/listMessage/projectPreview',
            name: 'projectPreview',
            component: () => import( /* webpackChunkName: "projectManagement" */
              '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/projectInit/projectPreview'
            ),
          },
          { //项目进度projectPlan
            path: '/projectsubject/projectManagement/listMessage/projectPlan',
            name: 'projectPlan',
            component: () => import( /* webpackChunkName: "projectManagement" */
              '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/projectPlan/projectPlan'
            ),
          },
          { //形象进度
            path: '/projectsubject/projectManagement/listMessage/imageProgressDetail',
            name: 'imageProgressDetail',
            meta: {
              menuIndex: true
            },
            component: () => import( /* webpackChunkName: "projectManagement" */
              '@/components/paging/pcClient/convenienceModule/projectManagement/imageProgress/imageProgressDetail'
            ),
          },
          { //工单督办
            path: '/projectsubject/projectManagement/listMessage/projectWorkOrder',
            name: 'projectWorkOrder',
            component: () => import( /* webpackChunkName: "projectWorkOrder" */
              '@/components/paging/pcClient/convenienceModule/businessAdministration/workOrder'
            ),
          },
          // { //物资管理
          //   path: '/projectsubject/projectManagement/listMessage/materialsManagement',
          //   name: 'materialsManagement ',
          //   component: () => import( /* webpackChunkName: "materialsManagement" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/materialsManagement'
          //   ),
          //   redirect: {
          //     name: 'warehouse'
          //   },
          //   children: [{ // 仓库
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/warehouse',
          //       name: 'warehouse',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/warehouse/warehouse'
          //       )
          //     },
          //     { // 验收
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/checkAndAccept',
          //       name: 'checkAndAccept',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/checkAndAccept/checkAndAccept'
          //       )
          //     },
          //     { // 入库
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/bePutInStorage',
          //       name: 'bePutInStorage',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/bePutInStorage/bePutInStorage'
          //       )
          //     },
          //     { // 发料
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/storeIssue',
          //       name: 'storeIssue',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/storeIssue/storeIssue'
          //       )
          //     },
          //     { // 盘点
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/stocking',
          //       name: 'stocking',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/stocking/stocking'
          //       )
          //     },
          //     { // 盘点详情
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/stockDetails',
          //       name: 'stockDetails',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/stocking/stockDetails'
          //       )
          //     },
          //     { // 验收详情
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/checkRecord',
          //       name: 'checkRecord',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/checkAndAccept/checkRecord'
          //       )
          //     },
          //     { // 添加验收
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/addCheck',
          //       name: 'addCheck',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/checkAndAccept/addCheck'
          //       )
          //     },
          //     { // 入库详情
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/bePutInStorageDetail',
          //       name: 'bePutInStorageDetail',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/bePutInStorage/bePutInStorageDetail'
          //       )
          //     },
          //     { // 添加入库
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/addBePutInStorage',
          //       name: 'addBePutInStorage',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/bePutInStorage/addBePutInStorage'
          //       )
          //     },
          //     { // 发料详情
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/storeIssueDetail',
          //       name: 'storeIssueDetail',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/storeIssue/storeIssueDetail'
          //       )
          //     },
          //     { // 待入库入库
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/sureBePutInStorage',
          //       name: 'sureBePutInStorage',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/bePutInStorage/sureBePutInStorage'
          //       )
          //     },
          //     { // 添加发料申请
          //       path: '/projectsubject/projectManagement/listMessage/materialsManagement/addStoreIssue',
          //       name: 'addStoreIssue',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "materialsManagement" */
          //         '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/storeIssue/addStoreIssue'
          //       )
          //     },
          //   ]
          // },
          { //项目信息
            path: '/projectsubject/projectManagement/listMessage/itemInformation',
            name: 'itemInformation',
            // meta: {menuIndex: true},
            component: () => import( /* webpackChunkName: "projectManagement" */
              '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/itemInformation/itemInformation'
            ),
          },
          { //项目信息修改
            path: '/projectsubject/projectManagement/listMessage/itemInformation/editor/:id/:bidId',
            name: 'informationEditor',
            meta: {
              menuIndex: true
            },
            component: () => import( /* webpackChunkName: "dataReport" */
              '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/itemInformation/informationEditor'
            ),
          },
          { //数据报表
            path: '/projectsubject/projectManagement/listMessage/dataReport',
            name: 'dataReport',
            component: () => import( /* webpackChunkName: "dataReport" */
              '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/dataReport/dataReport'
            ),
          },
          // { //项目文件
          //   path: '/projectsubject/projectManagement/listMessage/itemFile',
          //   name: 'itemFile',
          //   component: () => import( /* webpackChunkName: "itemFile" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/itemFile/itemFile'
          //   ),
          // },
          // { //项目文件发起审批
          //   path: '/projectsubject/projectManagement/listMessage/itemFile/approvalfile',
          //   name: 'approvalfile',
          //   meta: {
          //     menuIndex: true
          //   },
          //   component: () => import( /* webpackChunkName: "itemFile" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/itemFile/fileNav/file_pop_up/Approval'
          //   ),
          // },
          { //项目人员
            path: '/projectsubject/projectManagement/listMessage/peopleManage',
            name: 'peopleManage',
            component: () => import( /* webpackChunkName: "peopleManage" */
              '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/peopleManage/peopleManageList'
            ),
          },
          { //项目人员
            path: '/projectsubject/projectManagement/listMessage/projectDetails/:companyRoleType/:companyId/:companyStatus',
            name: 'projectDetails',
            meta: {
              menuIndex: true
            },
            component: () => import( /* webpackChunkName: "peopleManage" */
              '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/peopleManage/projectDetails'
            ),
          },
          { //项目添加企业
            path: '/projectsubject/projectManagement/listMessage/project_addcompany/:companyRoleType',
            name: 'addcompany',
            component: () => import( /* webpackChunkName: "peopleManage" */
              '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/peopleManage/project_addcompany'
            ),
          },
          // { //资金管理
          //   path: '/projectsubject/projectManagement/listMessage/fundsManagement',
          //   name: 'fundsManagement',
          //   component: () => import( /* webpackChunkName: "fundsManagement" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/fundsManagement/fundsManagement'
          //   ),

          // },
          // { //个人拨款明细
          //   path: '/projectsubject/projectManagement/listMessage/fundsManagement/allocatedDetail',
          //   name: 'allocatedDetail',
          //   meta: {
          //     menuIndex: true
          //   },
          //   component: () => import( /* webpackChunkName: "fundsManagement" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/fundsManagement/fundsManage/moneyAllocatedApply/allocatedDetail'
          //   ),

          // },
          // //   ================新增
          // { //编辑
          //   path: '/promanage/projectlist/fundsManagementEditorInfo/:id',
          //   name: 'fundsManagementEditorInfo',
          //   meta: {
          //     menuIndex: true
          //   },
          //   component: () => import( /* webpackChunkName: "fundsManagement" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/fundsManagement/fundsManage/editorInfo'
          //   ),
          // },

          // {
          //   path: '/promanage/projectlist/applyDatum',
          //   name: "applyDatum",
          //   component: () => import( /* webpackChunkName: "fundsManagement" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/fundsManagement/fundsManage/applyDatum'
          //   )
          // },
          // {
          //   path: '/promanage/projectlist/applyshengpi',
          //   name: "applyshengpi",
          //   component: () => import( /* webpackChunkName: "fundsManagement" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/fundsManagement/fundsManage/applyshengpi'
          //   )
          // },
          // {
          //   path: '/promanage/projectlist/sureGather/:id/:type',
          //   name: "sureGather",
          //   meta: {
          //     menuIndex: true
          //   },
          //   component: () => import( /* webpackChunkName: "fundsManagement" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/fundsManagement/fundsManage/sureGather'
          //   )
          // },
          // {
          //   path: '/promanage/projectlist/empty',
          //   name: "empty",
          //   component: () => import( /* webpackChunkName: "fundsManagement" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/fundsManagement/fundsManage/empty'
          //   )
          // },
          // // ===========end
          // // 项目合同管理contract
          // {
          //   path: '/promanage/projectlist/projectContract',
          //   name: 'projectContract',
          //   component: () => import( /* webpackChunkName: "comtract" */
          //     '@/components/paging/pcClient/convenienceModule/businessAdministration/contract/contract'),
          //   redirect: '/promanage/projectlist/projectContract/projectContractTable',
          //   children: [{ // 合同列表
          //       path: '/promanage/projectlist/projectContract/projectContractTable',
          //       name: 'projectContractTable',
          //       component: () => import( /* webpackChunkName: "comtract" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/contract/contractTable/contractTable'
          //       ),
          //     },
          //     { // 合同详情
          //       path: '/promanage/projectlist/projectContract/projectContractDetails',
          //       name: 'projectContractDetails',
          //       meta: {
          //         menuIndex: true
          //       },
          //       component: () => import( /* webpackChunkName: "comtract" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/contract/contractDetails/contractDetails'
          //       ),
          //     }
          //   ]
          // },
          // { //质量检查
          //   path: '/projectsubject/projectManagement/listMessage/qualityInspection',
          //   name: 'qualityInspection',
          //   component: () => import( /* webpackChunkName: "quality" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/qualityInspection/qualityInspection'
          //   ),
          // },
          // { //发起质量检查
          //   path: '/projectsubject/projectManagement/listMessage/qualityadd/:type',
          //   name: 'qualityadd',
          //   meta: {
          //     menuIndex: true
          //   },
          //   component: () => import( /* webpackChunkName: "quality" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/qualityInspection/qualityadd'
          //   ),
          // },
          // { //质量检查查看和编辑
          //   path: '/projectsubject/projectManagement/listMessage/qualitylookedit',
          //   name: 'qualitylookedit',
          //   component: () => import( /* webpackChunkName: "quality" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/qualityInspection/qualitylookedit'
          //   ),
          // },
          // { //发起安全检查
          //   path: '/projectsubject/projectManagement/listMessage/securityadd/:type',
          //   name: 'securityadd',
          //   meta: {
          //     menuIndex: true
          //   },
          //   component: () => import( /* webpackChunkName: "security" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/securityCheck/securityadd'
          //   ),
          // },
          // { //安全检查查看和编辑
          //   path: '/projectsubject/projectManagement/listMessage/securitylookedit',
          //   name: 'securitylookedit',
          //   component: () => import( /* webpackChunkName: "security" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/securityCheck/securitylookedit'
          //   ),
          // },
          // { //  安全检查 ，第一个版本
          //   path: '/projectsubject/projectManagement/listMessage/securityCheck',
          //   name: 'securityCheck',
          //   component: () => import(
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/securityCheck/securityCheck'
          //   ),
          // },
          // { // 安全质量检查 ，第二个版本
          //   path: '/projectsubject/projectManagement/listMessage/SafetyQualityInspection',
          //   name: 'SafetyQualityInspection',
          //   component: () => import( /* webpackChunkName: "SafetyQualityInspection" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/SafetyQualityInspection/SafetyQualityInspection'
          //   ),
          // },
          // { // 安全质量检查 ，详情页面
          //   path: '/projectsubject/projectManagement/listMessage/safetyDetails',
          //   name: 'safetyDetails',
          //   component: () => import( /* webpackChunkName: "safetyDetails" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/SafetyQualityInspection/safetyDetails.vue'
          //   ),
          // },
          // { //视频监控
          //   path: '/projectsubject/projectManagement/listMessage/videoSurveillance',
          //   name: 'videoSurveillance',
          //   component: () => import( /* webpackChunkName: "videoSurveillance" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/videoSurveillance/videoSurveillance'
          //   ),
          // },
          // { // 项目公告
          //   path: '/projectsubject/projectManagement/listMessage/projectNotice',
          //   name: 'projectNotice',
          //   component: () => import( /* webpackChunkName: "projectNotice" */
          //     '@/components/paging/pcClient/convenienceModule/businessAdministration/notice/notice'),
          //   children: [{ // 项目公告列表
          //       path: '/projectsubject/projectManagement/listMessage/projectNoticeList',
          //       name: 'projectNoticeList',
          //       component: () => import( /* webpackChunkName: "projectNoticeList" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/notice/noticeFiles/noticeList'
          //       ),
          //     },
          //     { // 添加编辑公告
          //       path: '/projectsubject/projectManagement/listMessage/editNotice',
          //       name: 'editNotice',
          //       component: () => import( /* webpackChunkName: "editNotice" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/notice/noticeFiles/editNotice'
          //       ),
          //     },
          //     { // 项目公告详情
          //       path: '/projectsubject/projectManagement/listMessage/noticeDetail',
          //       name: 'noticeDetail',
          //       component: () => import( /* webpackChunkName: "noticeDetail" */
          //         '@/components/paging/pcClient/convenienceModule/businessAdministration/notice/noticeFiles/noticeDetail'
          //       ),
          //     },
          //   ]
          // },
          // { //项目阶段
          //   path: '/projectsubject/projectManagement/listMessage/projectPhaseList',
          //   name: 'projectPhaseList',
          //   component: () => import( /* webpackChunkName: "videoSurveillance" */
          //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/projectPhase/projectPhaseList'
          //   ),
          // },
        ]
      },
      // { //归档备案
      //   path: '/projectsubject/projectManagement/archive',
      //   name: 'archive',
      //   component: () => import( /* webpackChunkName: "archive" */
      //     '@/components/paging/pcClient/convenienceModule/projectManagement/archive/archive'),
      // },
      // { //我的审批
      //   path: '/projectsubject/projectManagement/myApproval',
      //   name: 'myApproval',
      //   component: () => import( /* webpackChunkName: "myApproval" */
      //     '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/myApproval'),
      //   redirect: '/projectsubject/projectManagement/myApproval/fileApproval',
      //   children: [
      // {
      //   path: '/projectsubject/projectManagement/myApproval/fundApproval',
      //   name:"fundApproval",
      //   component:()=>import(/* webpackChunkName: "fundApproval" */ '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fundApproval/fundApproval'),
      //   redirect: '/projectsubject/projectManagement/myApproval/fundApproval/pendingApprove',
      //   children:[
      //     {//待我审批
      //     path: '/projectsubject/projectManagement/myApproval/fundApproval/pendingApprove',
      //     name: 'pendingApprove',
      //     component: () => import(/* webpackChunkName: "myApproval" */ '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fundApproval/approvePage/moneyApproval')
      //     },
      //     {//我已审批
      //       path: '/projectsubject/projectManagement/myApproval/fundApproval/alreadyApprove',
      //       name: 'alreadyApprove',
      //       component: () => import(/* webpackChunkName: "myApproval" */ '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fundApproval/approvePage/moneyApproval')
      //     },
      //     {//我发起的
      //       path: '/projectsubject/projectManagement/myApproval/fundApproval/initiateApprove',
      //       name: 'initiateApprove',
      //       component: () => import(/* webpackChunkName: "myApproval" */ '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fundApproval/approvePage/moneyApproval')
      //     },
      //     {//分类统计
      //       path: '/projectsubject/projectManagement/myApproval/fundApproval/sortStatistic',
      //       name: 'sortStatistic',
      //       component: () => import(/* webpackChunkName: "myApproval" */ '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fundApproval/approvePage/sortStatistic')
      //     },
      //   ]
      // },
      //   { //文件审批
      //     path: '/projectsubject/projectManagement/myApproval/fileApproval',
      //     name: 'fileApproval',
      //     component: () => import( /* webpackChunkName: "myApproval" */
      //       '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fileApproval/fileApproval'
      //     )
      //   },
      //   { //人事审批
      //     path: '/projectsubject/projectManagement/myApproval/humanResourcesView',
      //     name: "humanResourcesView",
      //     component: layoutsView,
      //     redirect: {
      //       name: 'vacationAttendanceApprove'
      //     },
      //     children: [{ //假勤审批
      //         path: '/projectsubject/projectManagement/myApproval/vacationAttendanceApprove',
      //         name: 'vacationAttendanceApprove',
      //         component: () => import( /* webpackChunkName: "myApproval" */
      //           '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/humanResourcesApproval/vacationAttendanceApprove'
      //         )
      //       },
      //       { //假勤审批详情
      //         path: '/projectsubject/projectManagement/myApproval/vacationAttendanceApproveDetail',
      //         name: 'vacationAttendanceApproveDetail',
      //         meta: {
      //           menuIndex: true
      //         },
      //         component: () => import( /* webpackChunkName: "myApproval" */
      //           '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/humanResourcesApproval/vacationAttendanceApprove/vacationAttendanceApproveDetail'
      //         )
      //       },
      //       { //人事档案审批
      //         path: '/projectsubject/projectManagement/myApproval/archivesApprove',
      //         name: 'archivesApprove',
      //         component: () => import( /* webpackChunkName: "myApproval" */
      //           '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/humanResourcesApproval/archivesApprove'
      //         )
      //       },
      //       { //人事档案审批详情
      //         path: '/projectsubject/projectManagement/myApproval/archivesApproveDetail',
      //         name: 'archivesApproveDetail',
      //         meta: {
      //           menuIndex: true
      //         },
      //         component: () => import( /* webpackChunkName: "myApproval" */
      //           '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/humanResourcesApproval/archivesApprove/archivesApproveDetail'
      //         )
      //       },
      //     ]
      //   }, {
      //     path: '/projectsubject/projectManagement/myApproval/fileApproval/approvalOperation',
      //     name: 'approvalOperation',
      //     meta: {
      //       menuIndex: true
      //     },
      //     component: () => import( /* webpackChunkName: "myApproval" */
      //       '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fileApproval/approval/approvalOperation'
      //     )
      //   },
      //   { //保证金申请
      //     path: '/projectsubject/projectManagement/myApproval/marginMoney',
      //     name: 'marginMoneyApplyFor',
      //     component: () => import( /* webpackChunkName: "marginMoneyApplyFor" */
      //       '@/components/paging/pcClient/convenienceModule/businessAdministration/financialManagement/marginMoney/applyFor'
      //     ),
      //   },
      //   { //保证金申请详情
      //     path: '/projectsubject/projectManagement/myApproval/marginMoney/marginMoneyList',
      //     name: 'marginMoneyApplyForList',
      //     meta: {
      //       menuIndex: true
      //     },
      //     component: () => import( /* webpackChunkName: "marginMoneyApplyFor" */
      //       '@/components/paging/pcClient/convenienceModule/businessAdministration/financialManagement/marginMoney/marginMoneyModule/applyForList'
      //     ),
      //   },
      //   { //保证金申请form
      //     path: '/projectsubject/projectManagement/myApproval/marginMoney/applyForFrom',
      //     name: 'applyForFrom',
      //     meta: {
      //       menuIndex: true
      //     },
      //     component: () => import( /* webpackChunkName: "marginMoneyApplyFor" */
      //       '@/components/paging/pcClient/convenienceModule/businessAdministration/financialManagement/marginMoney/marginMoneyModule/applyForFrom'
      //     ),
      //   },
      //   { //保证金申请完成清单详情
      //     path: '/projectsubject/projectManagement/myApproval/marginMoney/marginMoneyFilish',
      //     name: 'marginMoneyFilish',
      //     meta: {
      //       menuIndex: true
      //     },
      //     component: () => import( /* webpackChunkName: "marginMoneyApplyFor" */
      //       '@/components/paging/pcClient/convenienceModule/businessAdministration/financialManagement/marginMoney/marginMoneyModule/depositFilish'
      //     ),
      //   },
      //   // 新增历史列表
      //   {
      //     path: '/projectsubject/projectManagement/myApproval/historyList/:id',
      //     name: 'historyList',
      //     component: () => import( /* webpackChunkName: "myApproval" */
      //       '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fileApproval/fileHistoryList'
      //     ),
      //   },
      //   {
      //     path: '/projectsubject/projectManagement/myApproval/historyListXm/:id',
      //     name: 'historyListXm',
      //     meta: {
      //       menuIndex: true
      //     },
      //     component: () => import( /* webpackChunkName: "myApproval" */
      //       '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fileApproval/fileHistoryListXm'
      //     ),
      //   },
      //   {
      //     path: '/projectsubject/projectManagement/myApproval/historyListSp/:id',
      //     name: 'historyListSp',
      //     meta: {
      //       menuIndex: true
      //     },
      //     component: () => import( /* webpackChunkName: "myApproval" */
      //       '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fileApproval/fileHistoryListSp'
      //     ),
      //   },
      //   { //资金审批
      //     path: '/projectsubject/projectManagement/myApproval/fundApproval',
      //     name: "fundApproval",
      //     component: () => import( /* webpackChunkName: "myApproval" */
      //       '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fundApproval/fundApproval'
      //     ),
      //     redirect: '/projectsubject/projectManagement/myApproval/fundApproval/pendingApprove',
      //     children: [{ //待我审批
      //         path: '/projectsubject/projectManagement/myApproval/fundApproval/pendingApprove',
      //         name: 'pendingApprove',
      //         component: () => import( /* webpackChunkName: "fundApproval" */
      //           '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fundApproval/approvePage/moneyApproval'
      //         )
      //       },
      //       { //我已审批
      //         path: '/projectsubject/projectManagement/myApproval/fundApproval/alreadyApprove',
      //         name: 'alreadyApprove',
      //         component: () => import( /* webpackChunkName: "fundApproval" */
      //           '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fundApproval/approvePage/moneyApproval'
      //         )
      //       },
      //       { //我发起的
      //         path: '/projectsubject/projectManagement/myApproval/fundApproval/initiateApprove',
      //         name: 'initiateApprove',
      //         component: () => import( /* webpackChunkName: "fundApproval" */
      //           '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fundApproval/approvePage/moneyApproval'
      //         )
      //       },
      //       { //分类统计
      //         path: '/projectsubject/projectManagement/myApproval/fundApproval/sortStatistic',
      //         name: 'sortStatistic',
      //         component: () => import( /* webpackChunkName: "fundApproval" */
      //           '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fundApproval/approvePage/sortStatistic'
      //         )
      //       },
      //     ]
      //   },
      //   {
      //     path: '/promanage/fundApproval/fundApprovalDetails',
      //     name: 'fundApprovalDetails',
      //     meta: {
      //       menuIndex: true
      //     },
      //     component: () => import( /* webpackChunkName: "fundApproval" */
      //       '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/fundApproval/approvePage/fundApprovalDetails'
      //     ),
      //   },
      //   { // 证书借用审批
      //     path: '/projectsubject/projectManagement/myApproval/credential',
      //     name: 'credential',
      //     component: () => import( /* webpackChunkName: "credential" */
      //       '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/credentialApproval/credential'
      //     ),
      //   },
      //   { // 证书借用审批详情
      //     path: '/projectsubject/projectManagement/myApproval/credentialApprovalcourse',
      //     name: 'credentialApprovalcourse',
      //     meta: {
      //       menuIndex: true
      //     },
      //     component: () => import( /* webpackChunkName: "credentialApprovalcourse" */
      //       '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/credentialApproval/credentialApprovalcourse'
      //     ),
      //   },
      //   { // 发料
      //     path: '/projectsubject/projectManagement/myApproval/materialsApproval',
      //     name: 'materialsApproval',
      //     component: () => import( /* webpackChunkName: "materialsApproval" */
      //       '@/components/paging/pcClient/convenienceModule/projectManagement/projectList/materialsManagement/storeIssue/storeIssue'
      //     )
      //   },
      //   { // 安全整改/复查
      //     path: '/projectsubject/projectManagement/myApproval/security',
      //     name: 'myApprovalSecurity',
      //     component: () => import( /* webpackChunkName: "myApprovalSecurity" */
      //       '@/components/paging/pcClient/convenienceModule/projectManagement/myApproval/security/Security.vue'
      //     )
      //   },
      // ]
      // },
      // { //项目日志
      //   path: '/projectsubject/projectManagement/projectLog',
      //   name: 'projectLog',
      //   component: () => import( /* webpackChunkName: "projectLog" */
      //     '@/components/paging/pcClient/convenienceModule/projectManagement/projectLog/projectLog'),
      // },
      // { //施工日志
      //   path: '/projectsubject/projectManagement/siteBuildingLog',
      //   name: 'siteBuildingLog',
      //   component: () => import( /* webpackChunkName: "siteBuildingLog" */
      //     '@/components/paging/pcClient/convenienceModule/projectManagement/siteBuildingLog/index'),
      // },
      // { //监理日志
      //   path: '/projectsubject/projectManagement/supervisorLog',
      //   name: 'supervisorLog',
      //   component: () => import( /* webpackChunkName: "supervisorLog" */
      //     '@/components/paging/pcClient/convenienceModule/projectManagement/siteBuildingLog/index'),
      // },
      // { //项目进度
      //   path: '/projectsubject/projectManagement/projectSchedule',
      //   name: 'projectSchedule',
      //   component: () => import( /* webpackChunkName: "projectSchedule" */
      //     '@/components/paging/pcClient/convenienceModule/projectManagement/siteBuildingLog/index'),
      // },
      // { //回收站
      //   path: '/projectsubject/projectManagement/recycleBin',
      //   name: 'recycleBin',
      //   component: () => import( /* webpackChunkName: "recycleBin" */
      //     '@/components/paging/pcClient/convenienceModule/projectManagement/recycleBin/recycleBin'),
      // },
      //   ]
      // },
      // { //信息查询
      //   path: '/projectsubject/inquire',
      //   name: 'inquire',
      //   component: () => import( /* webpackChunkName: "inquire" */
      //     '@/components/paging/pcClient/convenienceModule/theRelatedQueries/inquire'),
      // },
      { //系统设置
        path: '/projectsubject/systemSettings',
        name: 'systemSettings',
        component: layoutsView,
        redirect: '/projectsubject/systemSettings/processTipsModule',
        children: [{
          path: '/projectsubject/systemSettings/processTipsModule',
          name: 'processTipsModule',
          component: layoutsView,
          redirect: '/projectsubject/systemSettings/processTipsView',
          children: [{ //系统设置
            path: '/projectsubject/systemSettings/processTipsView',
            name: 'processTipsView',
            component: layoutsView,
            redirect: {
              name: 'processTips'
            },
            children: [{
                path: '/projectsubject/systemSettings/processTips',
                name: 'processTips',
                meta: {
                  // menuIndex: true
                },
                component: () => import( /* webpackChunkName: "systemSettings" */
                  '@/components/paging/pcClient/convenienceModule/processTips'
                )
              },
              { // 告警设置
                path: '/projectsubject/systemSettings/workAlarm',
                name: 'workAlarm',
                meta: {
                  // menuIndex: true
                },
                component: () => import( /* webpackChunkName: "systemSettings" */
                  '@/components/paging/pcClient/convenienceModule/setWorkOrder/workAlarm'
                )
              },
              { // 工单时间管理设置
                path: '/projectsubject/systemSettings/setWorkOrder',
                name: 'setWorkOrder',
                meta: {
                  // menuIndex: true
                },
                component: () => import( /* webpackChunkName: "systemSettings" */
                  '@/components/paging/pcClient/convenienceModule/setWorkOrder'
                )
              },
              { // 管理员设置
                path: '/projectsubject/systemSettings/administratorSet',
                name: 'administratorSet',
                meta: {
                  // menuIndex: true
                },
                component: () => import( /* webpackChunkName: "systemSettings" */
                  '@/components/paging/pcClient/convenienceModule/setWorkOrder/administratorSet'
                )
              },
              { // 企业公告
                path: '/projectsubject/businessAdministration/notice',
                name: 'companyNotice',
                component: () => import( /* webpackChunkName: "companyNotice" */
                  '@/components/paging/pcClient/convenienceModule/businessAdministration/notice/notice'),
                redirect: '/projectsubject/businessAdministration/companyNoticeList',
                children: [{ // 企业公告列表
                    path: '/projectsubject/businessAdministration/companyNoticeList',
                    name: 'companyNoticeList',
                    component: () => import( /* webpackChunkName: "companyNoticeList" */
                      '@/components/paging/pcClient/convenienceModule/businessAdministration/notice/noticeFiles/noticeList'
                    ),
                  },
                  { // 添加编辑公告
                    path: '/projectsubject/businessAdministration/editNotice',
                    name: 'editNotice',
                    meta: {
                      menuIndex: true
                    },
                    component: () => import( /* webpackChunkName: "editNotice" */
                      '@/components/paging/pcClient/convenienceModule/businessAdministration/notice/noticeFiles/editNotice'
                    ),
                  },
                  { // 企业公告详情
                    path: '/projectsubject/businessAdministration/noticeDetail',
                    name: 'noticeDetail',
                    meta: {
                      menuIndex: true
                    },
                    component: () => import( /* webpackChunkName: "noticeDetail" */
                      '@/components/paging/pcClient/convenienceModule/businessAdministration/notice/noticeFiles/noticeDetail'
                    ),
                  }
                ]
              },
            ]
          }]
        }]
      },
      { //意见反馈
        path: '/projectsubject/feedback',
        name: 'feedback',
        component: () => import( /* webpackChunkName: "feedback" */
          '@/components/paging/pcClient/convenienceModule/feedback/feedback'),
      },
      { //消息
        path: '/projectsubject/message',
        name: 'message',
        component: () => import( /* webpackChunkName: "message" */
          '@/components/paging/pcClient/convenienceModule/message/message'),
      },
      // { //四屏
      //   path: '/projectsubject/fourScreens',
      //   name: 'fourScreens',
      //   component: () => import( /* webpackChunkName: "fourScreens" */
      //     '@/components/paging/pcClient/convenienceModule/fourScreens'),
      // },
      // { //用户
      //   path: '/projectsubject/userinfo',
      //   name: 'userinfo',
      //   component: () => import( /* webpackChunkName: "userinfo" */
      //     '@/components/paging/pcClient/convenienceModule/user/userinfo'),
      // },
    ]
  },
]

export default routerData



// WEBPACK FOOTER //
// ./src/router/routerData.js